export default __webpack_public_path__ + "static/media/ai_micActive.86056475.svg";